import { render } from "./MissionVision.vue?vue&type=template&id=568a640a"
import script from "./MissionVision.vue?vue&type=script&setup=true&lang=js"
export * from "./MissionVision.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/MissionVision.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "568a640a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('568a640a', __exports__)) {
    console.log('reload')
    api.reload('568a640a', __exports__)
  }
  
  module.hot.accept("./MissionVision.vue?vue&type=template&id=568a640a", () => {
    console.log('re-render')
    api.rerender('568a640a', render)
  })

}


export default __exports__